<template>
  <div class="profileparameterset-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('profileparameterset_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-file-cog-outline</v-icon>{{$t('profile.profileparameter.set')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ProfileParameterSetFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.date" slot-scope="{ item }">
                  {{ formatDate(item['date'], 'long') }}
                </template>
                <template slot="item.profileParameterSetValues" slot-scope="{ item }">
                  <ul>
                    <li v-for="_item in item['profileParameterSetValues']" :key="_item.id">
                      {{ _item.id }}
                    </li>
                  </ul>
                </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ProfileParameterSetFilterForm from '../../components/profileparameterset/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ProfileParameterSetList',
  servicePrefix: 'ProfileParameterSet',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    ProfileParameterSetFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.profileparameter.uuid'), value: 'uuid' },
        { text: this.$t('profile.profileparameter.setup'), value: 'setup.uuid' },
        { text: this.$t('profile.profileparameter.strategy'), value: 'strategy.uuid' },
        { text: this.$t('profile.profileparameter.date'), value: 'date' },
        { text: this.$t('profile.profileparameter.version'), value: 'version' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['date'], sortDesc : [true]}
    };
  },
  computed: {
    ...mapGetters('profileparameterset', {
      items: 'list'
    }),
    ...mapFields('profileparameterset', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('profileparameterset', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
